/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarouselRequestMoreImages_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_item">;
    readonly " $refType": "PdpRespHeroCarouselRequestMoreImages_item";
};
export type PdpRespHeroCarouselRequestMoreImages_item$data = PdpRespHeroCarouselRequestMoreImages_item;
export type PdpRespHeroCarouselRequestMoreImages_item$key = {
    readonly " $data"?: PdpRespHeroCarouselRequestMoreImages_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarouselRequestMoreImages_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item",
      "args": null
    }
  ]
};
(node as any).hash = '092c74d315099a40ad4b44ee46353114';
export default node;
